// extracted by mini-css-extract-plugin
export default {"quem-somos":"QuemSomos_quem-somos__+N9E1"};